import {NgModule} from '@angular/core';
import {ChatViewComponent} from "./components/chat-view/chat-view.component";
import {ConversationItemComponent} from "./components/conversation-item/conversation-item.component";
import {BrowserModule} from "@angular/platform-browser";
import {ChatConversationsListComponent} from "./components/chat-conversations-list/chat-conversations-list.component";
import {ChatConversationsListItemComponent} from "./components/chat-conversations-list-item/chat-conversations-list-item.component";
import {ChatConversationViewComponent} from "./components/chat-conversation-view/chat-conversation-view.component";
import {ChatConversationMessageComponent} from "./components/chat-conversation-message/chat-conversation-message.component";
import {FormsModule} from "@angular/forms";
import {ChatConversationTimePipe} from "./pipes/chat-conversation-time.pipe";
import {NgbModule} from "@ng-bootstrap/ng-bootstrap";
import {ChatUserInputComponent} from "./components/chat-user-input/chat-user-input.component";
import {ChatUserAvatarComponent} from "./components/chat-user-avatar/chat-user-avatar.component";
import {ChatConversationNamePipe} from "./pipes/chat-conversation-name.pipe";
import {ChatConversationSortPipe} from "./pipes/chat-conversation-sort.pipe";
import {ChatConversationServiceViewComponent} from "./components/chat-conversation-service-view/chat-conversation-service-view.component";
import {ServicesModule} from "../deliveries/angular/services.module";
import {CommonsModule} from "../commons/angular/commons.module";
import {TranslateModule} from "@ngx-translate/core";

@NgModule({
  imports: [
    FormsModule,
    BrowserModule,
    NgbModule,
    TranslateModule.forChild(),
    ServicesModule,
    CommonsModule
  ],
  declarations: [
    ChatViewComponent,
    ConversationItemComponent,
    ChatConversationsListComponent,
    ChatConversationsListItemComponent,
    ChatConversationViewComponent,
    ChatConversationMessageComponent,
    ChatUserInputComponent,
    ChatUserAvatarComponent,
    ChatConversationServiceViewComponent,
    ChatConversationTimePipe,
    ChatConversationNamePipe,
    ChatConversationSortPipe
  ],
  providers: [],
  exports: [
    ChatViewComponent,
    ConversationItemComponent,
    ChatConversationsListComponent,
    ChatConversationsListItemComponent,
    ChatConversationViewComponent,
    ChatConversationMessageComponent,
    ChatUserAvatarComponent,
    ChatConversationServiceViewComponent,
    ChatUserInputComponent
  ]
})
export class ChatModule {}
